import type { PoiImages } from '$lib/components/pois/types';
import type { Zoi } from '$lib/components/zoi/types';

export function mapImagesFromZoi(zoi: Zoi) {
	return zoi.zoiImages?.map(image => ({
		src: image.w160,
		alt: zoi.name,
		srcset: generateSrcset(image),
	})) ?? [];
}

export function generateSrcset(image: PoiImages) {
	return Object.entries(image)
		.filter(([width]) => width.startsWith('w'))
		.map(([width, src]) => `${src} ${width.replace('w', '')}w`)
		.join(', ');
}
